import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'warehouse-list',
  templateUrl: './warehouse-list.component.html',
  styleUrls: ['./warehouse-list.component.scss']
})
export class WarehouseListComponent implements OnInit {

  public loading: boolean = true;
  public faPlusCircle = faPlusCircle;
  
  constructor(public router: Router) { }
  
  ngOnInit() {
  }

  onLoaded(){
    this.loading = false;
  }

}
